import IMotivoLancamentoManual from "../interfaces/IMotivoLancamentoManual";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class MotivoLancamentoManualService {
    async getById(id: string) {
        return await api.get<IMotivoLancamentoManual>(`${resources.motivoLancamentoManual}/GetById/${id}`);
    }

    async create(data: any) {
        return await api.post<IMotivoLancamentoManual>(`${resources.motivoLancamentoManual}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.motivoLancamentoManual}/Update`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.motivoLancamentoManual}/Delete/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.motivoLancamentoManual}/GetWithFilter/${ToQueryString(filters)}`);
    }
}

export default new MotivoLancamentoManualService();
